import { DEFAULT_PREFIX } from "@giantmachines/redux-websocket";

export const Prefixs = {
  DEFAULT_PREFIX: DEFAULT_PREFIX,
  MACHINE_PREFIX: `MACHINE_${DEFAULT_PREFIX}`,
  CAMERA_PREFIX: `CAMERA_${DEFAULT_PREFIX}`,
  TRAIN_PREFIX: `TRAIN_${DEFAULT_PREFIX}`,
  PREDICTION_PREFIX: `PREDICTION_${DEFAULT_PREFIX}`,
  BATCH_PREDICTION_PREFIX: `BATCH_PREDICTION_${DEFAULT_PREFIX}`,
  DEPLOY_PREFIX: `DEPLOY_${DEFAULT_PREFIX}`,
  DOWNLOAD_PREFIX: `DOWNLOAD_${DEFAULT_PREFIX}`,
  CAMERA_GROUP_PREFIX: `CAMERA_GROUP_${DEFAULT_PREFIX}`,
};

export const isSocketPrefix = (prefix) => {
  return Object.values(Prefixs).findIndex((e) => e === prefix) >= 0;
};
